import { OpFile } from '../models/core/op-file'
import { Enums } from '../models/common/enums'


export class FileComponent {
    public static OpenFileSaver(toSave: OpFile): void {
        if (toSave == null || toSave.fileBytes == null)
            throw Error("OpenFileSaver - no file to save")
        var bytes = new Uint8Array(<number[]>toSave.fileBytes)
        var FileSaver = require('file-saver')
        var blob = new Blob([bytes], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, toSave.physicalFileName)
    }

    public static isImageFile(file: OpFile): boolean {
        return file.fileBytes.length != 0 &&
            (
                file.extension === Enums.FileExtension.Jpg
                || file.extension === Enums.FileExtension.Jpeg
                || file.extension === Enums.FileExtension.Png
                || file.extension === Enums.FileExtension.Bmp
            )
    }
}